if (!customElements.get('pb-mug-free-shipping')) {
  customElements.define('pb-mug-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.labels = JSON.parse(this.querySelector('script').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale === 'no' ? 'nb-NO' : this.dataset.locale, {style:'currency',currency:'NOK',minimumFractionDigits:2,maximumFractionDigits:2});
      this.render(Number(this.dataset.total));
      const refresh = () => {clearTimeout(this.refreshTimer);this.refreshTimer=setTimeout(() => this.refresh(),80)};
      const bubble = document.querySelector('#cart-icon-bubble');
      this.cartObserver = new MutationObserver(refresh);
      if (bubble) this.cartObserver.observe(bubble,{childList:true,subtree:true,characterData:true});
      for (const event of ['afterCartChanged','afterUpdateQuantity','afterDiscountUpdate']) document.addEventListener(event, refresh, {signal:this.abort.signal});
      window.addEventListener('pageshow', refresh, {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh()}, {signal:this.abort.signal});
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const response = await fetch(this.dataset.cartUrl, {headers:{Accept:'application/json'},cache:'no-store',signal:this.abort.signal});
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (revision !== this.revision || !this.isConnected) return;
        this.hidden = cart.currency !== 'NOK';
        if (!this.hidden) this.render(cart.total_price);
      } catch (error) {
        if (error.name !== 'AbortError' && revision === this.revision) this.hidden = true;
      }
    }
    render(total) {
      const threshold = Number(this.dataset.threshold);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.max(0, Math.min(100, total / threshold * 100));
      const message = remaining === 0 ? this.labels.reached : total === 0 ? this.labels.empty : this.labels.remaining.replace('__AMOUNT__', this.money.format(remaining / 100));
      const text = this.querySelector('[data-pbm-shipping-message]');
      if (text.textContent !== message) text.textContent = message;
      const track = this.querySelector('[role=progressbar]');
      track.setAttribute('aria-valuenow', String(Math.round(progress)));
      track.setAttribute('aria-valuetext', message);
      track.firstElementChild.style.width = `${progress}%`;
      this.classList.toggle('is-complete', remaining === 0);
    }
    disconnectedCallback() {this.abort?.abort();this.cartObserver?.disconnect();clearTimeout(this.refreshTimer)}
  });
}

